import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import QuestionHeader from './QuestionHeader';
import AnswerList from './AnswerList';
import QuestionBottomBar from './QuestionBottomBar';

class QuestionItem extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    updateQuestion: PropTypes.func.isRequired,
    moveQuestionUp: PropTypes.func.isRequired,
    moveQuestionDown: PropTypes.func.isRequired,
    deleteQuestion: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.remove = this.remove.bind(this);
  }

  update(fields) {
    const { question } = this.props;
    this.props.updateQuestion({
      ...question,
      ...fields,
    });
  }

  moveUp() {
    const { question } = this.props;
    this.props.moveQuestionUp(question.id);
  }

  moveDown() {
    const { question } = this.props;
    this.props.moveQuestionDown(question.id);
  }

  remove() {
    const { question } = this.props;
    this.props.deleteQuestion(question);
  }

  render() {
    const { question, ...rest } = this.props;

    return (
      <div className="ui raised segments">
        <QuestionHeader
          question={question}
          update={this.update}
          moveUp={this.moveUp}
          moveDown={this.moveDown}
          remove={this.remove}
          {...rest}
        />
        <AnswerList question={question} answers={question.answers} {...rest} />
        <QuestionBottomBar question={question} />
      </div>
    );
  }
}

export default pure(QuestionItem);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/QuestionItem.js